import { memo } from 'react';

import { Button, ButtonText } from '@/components/ui/button';
import { getAccessibilityProps } from '@/util/accessibilityProps';

const LEAVE_FEEDBACK_LABEL = 'Leave feedback';

/**
 * "Leave feedback" action for the inquiry action bar.
 *
 * Scaffold only: rendered behind INQUIRY_LEAVE_FEEDBACK so the bar's second slot
 * and multi-action layout exist before the real feedback flow does. A neutral
 * outline button — clean visual hierarchy below the primary On your honor toggle.
 * `onPress` is a placeholder until the real flow lands.
 */
export const LeaveFeedbackAction = memo(function LeaveFeedbackAction({
  onPress,
  isSending,
}: {
  onPress: () => void;
  isSending: boolean;
}) {
  return (
    <Button
      size="2xs"
      action="secondary"
      className="border-secondary-400 data-[hover=true]:border-secondary-500"
      variant="outline"
      onPress={onPress}
      isDisabled={isSending}
      {...getAccessibilityProps({ label: LEAVE_FEEDBACK_LABEL, role: 'button' })}>
      <ButtonText className="text-secondary-500 data-[hover=true]:text-secondary-600 data-[active=true]:text-secondary-700">
        {LEAVE_FEEDBACK_LABEL}
      </ButtonText>
    </Button>
  );
});
